window["GAUGES_NO_AUTO_INIT"] = true;

//import 'highcharts';
//(<any>window).Highcharts = Highcharts;
//console.log((<any>window).Highcharts);
//import "highcharts-ng";
import { StaticProvider } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { downgradeModule } from "@angular/upgrade/static";
import "@uirouter/angularjs";
import "@uirouter/angularjs/release/stateEvents"; // this polyfills old transition events
import "@uirouter/sticky-states";
import * as angular from "angular";
import "angular-animate";
import "angular-aria";
import "angular-cache";
import "angular-material";
import "angular-messages";
import "angular-sanitize";
import "highcharts-ng";
import { NgAppModule } from "src/app/app.module";
import "./directives/directives.module.ajs";
import "./filters/filters.module";
import { Config } from "./index.config";
import "./index.constants";
import { RouteConfig } from "./index.route";
//import "../app.js";
import { RunBlock } from "./index.run";
import "./main/components/components.modules.ajs";
import "./main/components/resourceManagement/resourceManagement.module.ajs";
import "./main/modules/foundation/foundation.module.ajs";
import "./main/modules/help/help.module.ajs";
import "./main/navigation/navigation.module";
import "./main/modules/tms/tms.module.ajs";
import "./main/modules/fleet/fleet.module.ajs";
import "./main/pages/auth/login/login.module";
import "./services/_services.module.ajs";
//import "angular-translate";
//import "pascalprecht-translate";
import "./styles/global.scss";
import "./userPreferences/userpreferences.module";
import "./main/modules/alerts/alerts.module.ajs";
import "./main/modules/foundation/foundation.module.ajs";
import "./main/modules/temperature/temperature.module.ajs";
import "./main/modules/maintenance/maintenance.module.ajs";
import "./main/modules/dashboard/dashboard.module.ajs";

const ng2BootstrapFn = (extraProviders: StaticProvider[]) => platformBrowserDynamic(extraProviders).bootstrapModule(NgAppModule);

export class AppModule {
}

const MODULE_NAME = 'veriApp';

export default MODULE_NAME;

/**
 * Main application
 */
angular
    .module(MODULE_NAME, [
        "constants",
        // External modules
        "ngSanitize",
        "ngMaterial",
        "highcharts-ng",
        "ngAnimate",
        "ui.router",
        //"ct.ui.router.extras.sticky",
        "ui.router.state.events",

        // App modules
        //"app.core",
        "app.userpreferences",
        "app.navigation",
        "app.pages.auth.login",
        "app.foundation",
        //"app.pages.coming-soon",
        //"app.pages.error-404",
        //"app.pages.error-500",
        "app.components",
        "app.components.util.api",
        "app.filters",
        "app.directives",
        "app.tms",
        "app.help",
        "app.fleet",
        "app.components.maintenance",
        "app.resourceManagement",
        "app.temperature",
        "app.alerts",
        "app.dashboard",
        downgradeModule(ng2BootstrapFn)
    ])
    .config(RouteConfig)
    .config(Config)
    .run(RunBlock);

// Done this way to prevent type errors
window["Highcharts"].setOptions({
    chart: {
        style: {
            fontFamily: "Inter, Roboto"
        }
    },
    global: {
        useUTC: false
    },
    lang: {
        thousandsSep: ","
    }
});
